module.exports = __webpack_public_path__ + "assets/manual_shortTermAccident-a8d70c4ff3c901b68ca5aa6f4d79048d.pdf";